import React from 'react';

interface InvalidValueErrorMessageProps {
  differenceAmount: number;
}
export const InvalidValueErrorMessage: React.FC<InvalidValueErrorMessageProps> = ({ differenceAmount }) => {
  return (
    <>
      <div className="text-red text-sm ">{"Input value doesn't match original value "}</div>
      <div className="text-red text-sm border-l-red ">
        {0 < differenceAmount ? ':add ' : ': remove '}
        {+Math.abs(0 - differenceAmount)} {"or changes wouldn't be saved"}
      </div>
      <div className="text-red text-sm "></div>
    </>
  );
};
